export default "__VITE_ASSET__ed9c481c__"